var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 40" } },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#F2F2F7",
          "fill-rule": "evenodd",
          d:
            "M10.256 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 39.48 3.9c.666 1.244 1.019 2.473 1.019 5.87v20.483c0 3.397-.353 4.63-1.02 5.874a6.946 6.946 0 0 1-2.86 2.858C35.382 39.648 34.148 40 30.75 40H10.256c-3.398 0-4.633-.353-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858C.853 34.884.5 33.65.5 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.91 6.91 0 0 1 4.38 1.02C5.633.357 6.858 0 10.256 0z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#4185F3",
          d:
            "M24.587 24.225h-9.146l-3.917 6.841c.471.24 1.006.394 1.352.394 3.598 0 10.941-.054 14.586-.054.375 0 .726-.127 1.04-.328l-3.915-6.853z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#1767D1",
          d:
            "m11.524 31.067 3.917-6.841H7.504c-.004.475.165.91.43 1.406.738 1.38 1.986 3.587 2.72 4.74.18.284.898.71.87.695z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#E94235",
          d:
            "m24.587 24.225 3.917 6.852c.508-.322.921-.833 1.19-1.304a373.85 373.85 0 0 1 2.339-4.025c.329-.557.456-1.056.449-1.523h-7.895z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#30A753",
          d:
            "m15.441 24.225 4.569-7.942-4.083-6.808c-.442.29-.82.685-.991.985-1.783 3.126-5.373 9.532-7.178 12.698a1.957 1.957 0 0 0-.255 1.067h7.938z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#F9BC00",
          d:
            "m24.587 24.225-4.577-7.942 3.971-6.8c.442.29.926.677 1.098.977 1.782 3.126 5.372 9.532 7.179 12.698.186.326.242.694.224 1.067h-7.895z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#0F8038",
          d:
            "m15.926 9.476 4.084 6.807 3.97-6.8c-.41-.24-.99-.381-1.552-.4-1.564-.051-4.1-.072-5.465-.013-.337.015-1.033.404-1.037.406z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }